{
  "name": "bids-validator",
  "version": "1.15.0",
  "description": "",
  "main": "./dist/commonjs/index.js",
  "exports": {
    ".": {
      "import": "./dist/esm/index.js",
      "require": "./dist/commonjs/index.js"
    },
    "./cli": {
      "require": "./dist/commonjs/cli.js"
    },
    "./utils/consoleFormat": {
      "require": "./dist/commonjs/consoleFormat.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "node ./esbuild.mjs",
    "prepublishOnly": "npm run build"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/bids-standard/bids-validator.git"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "bin": {
    "bids-validator": "bin/bids-validator"
  },
  "author": "Squishymedia",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/bids-standard/bids-validator/issues"
  },
  "homepage": "https://github.com/bids-standard/bids-validator",
  "dependencies": {
    "@aws-sdk/client-s3": "^3.637.0",
    "ajv": "^6.5.2",
    "bytes": "^3.1.2",
    "colors": "^1.4.0",
    "cross-fetch": "^4.0.0",
    "date-fns": "^4.1.0",
    "events": "^3.3.0",
    "exifreader": "^4.23.7",
    "hed-validator": "^3.15.5",
    "ignore": "^6.0.2",
    "is-utf8": "^0.2.1",
    "jest": "^29.7.0",
    "jshint": "^2.13.6",
    "lerna": "^8.1.8",
    "lodash": "^4.17.21",
    "minimatch": "3.0.5",
    "next": "14.2.15",
    "nifti-js": "^1.0.1",
    "p-limit": "^2.1.0",
    "pako": "^1.0.6",
    "path": "^0.12.7",
    "pluralize": "^8.0.0",
    "semver": "^7.6.3",
    "stream-browserify": "^3.0.0",
    "table": "^6.8.2",
    "util": "^0.12.5",
    "xml2js": "^0.6.2",
    "yaml": "^2.3.1",
    "yargs": "^17.7.2"
  },
  "devDependencies": {
    "adm-zip": "",
    "chai": "",
    "esbuild": "^0.24.0",
    "esbuild-plugin-globals": "^0.2.0",
    "esbuild-runner": "^2.2.2",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.2.1",
    "husky": "^9.1.6",
    "lockfile": "^1.0.4",
    "sync-request": "6.1.0"
  },
  "browser": {
    "fs": false,
    "child_process": false,
    "stream": "stream-browserify"
  },
  "files": [
    "dist/*",
    "schema/*"
  ],
  "gitHead": "250e52c4e611c41e6360873cbfaada65ab0eddb9"
}
